/* eslint-disable max-lines-per-function */
import { Routes, Route } from 'react-router-dom';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import {
  DetailsPage,
  OverviewPage,
} from '@/domain/mitarbeiter/pages/rotationsplan';
import { Anlageassistent } from '@/domain/mitarbeiter/pages/anlageassistent';
import { DefaultPage } from '@/pages/DefaultPage';
import { CreateRotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateRotationsplan/CreateRotationsplan';
import { WithLocationGuard } from '@/features/locationGuard/WithLocationGuard';
import { buildLink } from '@/utils';
import { CreateStation } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateStation/CreateStation';
import { Suspense } from 'react';
import { SheetWrapper } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SheetWrapper/SheetWrapper';
import { UpdateStation } from '@/domain/mitarbeiter/features/rotationsplan/features/UpdateStation/UpdateStation';
import { Toaster } from '@e2n/ui/v2';
import { WithRotationsplanBenutzerrecht } from '@/domain/mitarbeiter/pages/rotationsplan/WithRotationsplanBenutzerrecht';
import { SuccessPage } from '@/domain/mitarbeiter/pages/anlageassistent/SuccessPage';
import { CreateBewertung } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateBewertung/CreateBewertung';
import { UpdateBewertung } from '@/domain/mitarbeiter/features/rotationsplan/features/UpdateBewertung/UpdateBewertung';
import { CreateRotationsplanVorlage } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateRotationsplanVorlage/CreateRotationsplanVorlage';

export function Mitarbeiter() {
  return (
    <Routes>
      <Route
        path="/rotationsplaene"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <WithRotationsplanBenutzerrecht>
                <OverviewPage view="planung" />
              </WithRotationsplanBenutzerrecht>
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }></Route>

      <Route
        path="/rotationsplaene/planung"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <WithRotationsplanBenutzerrecht>
                <OverviewPage view="planung" />
              </WithRotationsplanBenutzerrecht>
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }></Route>
      <Route
        path="/rotationsplaene/uebersicht"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <WithRotationsplanBenutzerrecht>
                <OverviewPage view="uebersicht" />
              </WithRotationsplanBenutzerrecht>
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }>
        <Route path="create" element={<CreateRotationsplan />} />
      </Route>
      <Route
        path="/rotationsplaene/vorlagen"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <WithRotationsplanBenutzerrecht>
                <OverviewPage view="vorlagen" />
              </WithRotationsplanBenutzerrecht>
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }>
        <Route path="create" element={<CreateRotationsplanVorlage />} />
      </Route>
      <Route
        path="/rotationsplan/:id"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <WithRotationsplanBenutzerrecht>
                <DetailsPage />
              </WithRotationsplanBenutzerrecht>
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }>
        <Route
          path=":abschnittId/station"
          element={
            <Suspense fallback={<></>}>
              <SheetWrapper />
            </Suspense>
          }>
          <Route path="create" element={<CreateStation />} />
          <Route path=":stationId/update" element={<UpdateStation />} />
          <Route
            path=":stationId/bewertung/create"
            element={<CreateBewertung />}
          />
          <Route
            path=":stationId/bewertung/:bewertungId"
            element={<UpdateBewertung />}
          />
        </Route>
      </Route>
      <Route
        path="/create/*"
        element={
          <MitarbeiterRoutesWrapper hideNavigation>
            <WithLocationGuard
              countries={['DE']}
              fallbackURL={buildLink('mitarbeiterListe')}>
              <WithFeatureFlags name="mitarbeiteranlage">
                <Anlageassistent />
              </WithFeatureFlags>
            </WithLocationGuard>
          </MitarbeiterRoutesWrapper>
        }
      />
      <Route
        path="/create/success"
        element={
          <MitarbeiterRoutesWrapper hideNavigation>
            <WithLocationGuard
              countries={['DE']}
              fallbackURL={buildLink('mitarbeiterListe')}>
              <WithFeatureFlags name="mitarbeiteranlage">
                <SuccessPage />
              </WithFeatureFlags>
            </WithLocationGuard>
          </MitarbeiterRoutesWrapper>
        }
      />
    </Routes>
  );
}

export function MitarbeiterRoutesWrapper({
  hideNavigation = false,
  children,
}: {
  hideNavigation?: boolean;
  children: React.ReactNode;
}) {
  if (hideNavigation) {
    return (
      <>
        {children}
        <Toaster />
      </>
    );
  }
  return <DefaultPage>{children}</DefaultPage>;
}
